// automatically generated by the FlatBuffers compiler, do not modify

export enum EscalatorControl {
  RunUp = 0,
  RunDown = 1,
  Stop = 2
}
